import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { format, parseISO } from "date-fns";
import { fullDateFullYearFormat } from "@common/helpers/date";
import { ClientsWorkOverviewRow } from "../clientsWorkOverviewViewConfig";
import { EMPTY_CELL_VALUE } from "./emptyCellValue";

/** A work date as the List shows it. */
export const formatWorkDate = (date: string) =>
    format(parseISO(date), fullDateFullYearFormat);

const makeDateCell = (field: "startDate" | "endDate" | "createdAt") =>
    memo(
        ({
            row,
        }: CellContext<
            ViewTableFeatures,
            ClientsWorkOverviewRow,
            string | null
        >) => {
            if (row.original.rowType !== "work") {
                return EMPTY_CELL_VALUE;
            }
            const date = row.original[field];
            if (!date) {
                return EMPTY_CELL_VALUE;
            }
            return <span>{formatWorkDate(date)}</span>;
        },
    );

export const WorkCloseStartDateCell = makeDateCell("startDate");
WorkCloseStartDateCell.displayName = "WorkCloseStartDateCell";

export const WorkCloseEndDateCell = makeDateCell("endDate");
WorkCloseEndDateCell.displayName = "WorkCloseEndDateCell";

export const WorkAppliedAtCell = makeDateCell("createdAt");
WorkAppliedAtCell.displayName = "WorkAppliedAtCell";
